import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class PolicyTypeService {
    async getSelectablePolicyTypes(organisationId: string, environmentName: string) {
        let params = `organisationId=${organisationId}&environmentName=${environmentName}`
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/PolicyType/getSelectablePolicyTypes?${params}`;
        let response = await getAuthenticatedFetch()(url);
        
        return response.json();
    }

    async updatePolicyTypesWithNewPolicyTypes(organisationId: string, environmentName: string, newlySelectedPolicyTypeIds: string[]) {
        const response = await getAuthenticatedFetch()(`${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/PolicyType/updatePolicyTypesWithNewPolicyTypes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                newlySelectedPolicyTypeIds,
                customerOrganisationId: organisationId,
                environmentName
            })
        });

        if (!response.ok) {
            const errorBody = await response.text();
            throw new Error(`API call failed: ${response.status} - ${errorBody}`);
        }

        return response;    }    
}

export default new PolicyTypeService();
